const highlightMetadata = {
    "00386_20260422.jpg": { title: "Her - Quiet Bloom (2026)", size: "117 x 91 cm" },
    "00387_20260422.jpg": { title: "Her - She Carries the Wind (2026)", size: "117 x 91 cm" },
    "00385_20260319.jpg": { title: "Her - Veiled in Green (2026)", size: "53 x 46 cm" },

    "00357_20250614.jpg": { title: "Her - Hanji Series (2025)", size: "65 x 53 cm" },
    "00353_20250614.jpg": { title: "Her - Hanji Series (2025)", size: "73 x 61 cm" },
    "00350_20250406.jpg": { title: "Her - Hanji Series (2025)", size: "18 x 26 cm" },
    // "00318_20250406.jpg": { title: "Her - Hanji Series (2024)", size: "20 x 20 cm" },
    "00328_20240626.jpg": { title: "Her - Fragments of Identity (2024)", size: "73 x 91 cm" },
    // "00326_20240503.jpg": { title: "Her - Ink Reverie (2024)", size: "73 x 91 cm" },
    "00188_20190413.jpg": { title: "Tribute - Monroe (2019)", size: "38 x 55 cm" },
    "00171_20180710.jpg": { title: "The Masquerade (2018)", size: "61 x 73 cm" },
    "00120_20140413.jpg": { title: "Peace - Autumn (2013)", size: "50 x 50 cm" },
    "00117_20140413.jpg": { title: "Peace - Summer (2013)", size: "50 x 50 cm" },
    "00035_20110413.jpg": { title: "Blessing (2011)", size: "65 x 80 cm" },
    "00023_20080516.jpg": { title: "Adversity (2008)", size: "80 x 100 cm" },
    "00020_20080413.jpg": { title: "Vortex (2008)", size: "117 x 91 cm" },

    
};

export default highlightMetadata;
